<template>
    <el-form :model="purchReceipt" :rules="rules" ref="ruleForm" class="demo-ruleForm">
        <div class="content-caption dashed">
            <span>验收单信息</span>
        </div>
        <div class="simple-form flex col-4">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">收货单</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="recvVoucherNo" :rules="{validator : checkNullModel, trigger: 'change'}">
                        <el-input class="width-1-5x bottom-line" disabled type="text" v-model="purchReceipt.recvVoucherNo"></el-input>
                        <div v-if="recvVoucherId == null" class="form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon" title="选择" @click="selectRecvVoucher()"></div>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>标题</label>
                </div>
                <div class="form-value">
                    <span>{{purchReceipt.title || '无'}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>收货日期</label>
                </div>
                <div class="form-value">
                    <span>{{purchReceipt.recvDate}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>交易单号</label>
                </div>
                <div class="form-value">
                    <span>{{purchReceipt.tradeNo}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>订单编号</label>
                </div>
                <div class="form-value">
                    <span>{{purchReceipt.orderNo}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>卖家</label>
                </div>
                <div class="form-value">
                    <span>{{purchReceipt.sellerName}}</span>
                </div>
            </div>
            <div class="form-group center" v-if="showBizUnitWarehouse">
                <div class="form-label">
                    <label class="required">入库仓库</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="warehouseId">
                        <el-select v-model="warehouseId" :clearable=true>
                            <el-option v-for="item in warehouseList" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>&nbsp;</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="autoReceive">
                        <el-checkbox v-model="purchReceipt.autoReceive" @change="changeAutoReceive">机构负责人自动领用</el-checkbox>
                    </el-form-item>
                </div>
            </div>
        </div>
        <div class="content-caption dashed">
            <span>验收条目</span>
        </div>
        <div class="simple-row">
            <div class="left">
                <a class="swb-btn swb-btn-small" @click="selectRecvItems()">选择商品</a>
            </div>
            <div class="right">
                <a class="swb-btn swb-btn-small swb-btn-primary" @click="refreshQuantity()">刷新数量</a>
            </div>
        </div>
        <div class="table-layout">
            <div v-if="purchReceipt.itemList != null && purchReceipt.itemList.length > 0">
                <div class="simple-row">
                    <div class="right">
                        <span v-if="purchReceipt.itemList != null">已选择({{purchReceipt.itemList.length}})</span>
                    </div>
                </div>
                <el-table ref="multipleTable" :data="purchReceipt.itemList" border tooltip-effect="dark" maxHeight="400" style="width: 100%">
                    <el-table-column align="left" prop="goodsTitle" label="商品名称" width="200" fixed="left" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" prop="catName" label="分类" width="100" fixed="left" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" prop="brandName" label="品牌" width="100" fixed="left" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" prop="model" label="型号" width="150" fixed="left" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" prop="fixedSpec" label="规格" width="150" fixed="left" show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" prop="tmpNo" label="系统编号" width="240"></el-table-column>
                    <el-table-column align="right" prop="recvQuantity" width="80" label="收货数量"></el-table-column>
                    <el-table-column align="right" prop="exchgSumQuantity" width="95" label="已换货数量"></el-table-column>
                    <el-table-column align="right" prop="returnSumQuantity" width="95" label="已退货数量"></el-table-column>
                    <el-table-column align="right" prop="assetCheckedQuantity" width="95" label="已验收数量"></el-table-column>
                    <el-table-column align="right" prop="quantity" width="100" label="本次验收数量">
                        <template slot-scope="rows">
                            <el-input type="text" disabled v-model="rows.row.quantity" @change="quantityChange(rows.row)"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="unit" min-width="50" label="单位"></el-table-column>
                    <el-table-column prop="taxRate" align="right" width="100" label="税率(%)">
                        <template slot-scope="rows">
                            <span>{{(rows.row.taxRate || 0).toFixed(2)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="ntxPrice" align="right" width="100" label="未税单价(元)">
                        <template slot-scope="rows">
                            <span v-if="rows.row.ntxPrice != null">{{rows.row.ntxPrice.toFixed(2)}}</span>
                            <span v-else>0.00</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="wtxPrice" align="right" width="100" label="含税单价(元)">
                        <template slot-scope="rows">
                            <span v-if="rows.row.wtxPrice != null">{{rows.row.wtxPrice.toFixed(2)}}</span>
                            <span v-else>0.00</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="taxOffset" align="center" width="90" label="购置可抵税">
                        <template slot-scope="rows">
                            <span class="font-red" v-if="rows.row.taxOffset">是</span>
                            <span v-else>否</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="invoiceState" width="100" label="开票状态">
                        <template slot-scope="rows">
                            <span>{{invoiceStateMap[rows.row.invoiceState]}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="invoiceType" width="130" label="发票类型">
                        <template slot-scope="rows">
                            <span>{{invoiceTypeMap[rows.row.invoiceType]}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="assetType" width="130" label="管理方式">
                        <template slot-scope="rows">
                            <span>{{ assetTypeMap[rows.row.assetType] }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="customized" align="center" width="90" label="是否定制">
                        <template slot-scope="rows">
                            <span>{{ rows.row.customized ? '是' : '否' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" width="100" label="操作" fixed="right">
                        <template slot-scope="rows">
                            <a class="swb-btn-link" @click="removeGoods(rows.$index)">移除</a>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </el-form>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox, Routes} from '../../app.vues'
    import {showGoodsRecvVoucherListForSelectDialog, showGoodsRecvVoucherItemListForSelectDialog} from '../order/dialog'
    import {getMerchantBizParam} from '../asset/assetMain'
    import { isSysRescFrozenIsAllowed } from '../index';

    import receiptApi from '../../api/receipt'
    import goodsDelivApi from '../../api/goodsDeliv'
    import merchtComnApi from '../../api/merchtComn'
    import shopStockApi from '../../api/shopStock'
    import retailerApi from '../../api/retailer'

    export default{
        name: 'swb-purch-receipt-save',
        desc: '购置验收保存',
        props: {
            id: {
                type: Number,
                default: null
            },
            recvVoucherId: {
                type: Number,
                default: null
            },
            recvBizUnitId: {
                type: Number,
                default: null
            },
            recvShopId: {
                type: Number,
                default: null
            },
            purchReceiptParam: {
                type: Object,
                default: null
            }
        },
        data: function () {
            let checkNull = function (rule, value, callback) {
                if (Utils.isNoB(value) && Utils.isFalse(this.buildFlag)) {
                    callback(new Error('不能为空'));
                } else {
                    callback();
                }
            };
            return {
                purchReceipt: {
                    itemList: [],
                    tradeNo: null,
                    invoiceType: null,
                    autoReceive: false
                },
                principalId: null,
                activeName: 'device',
                rules: {
                    recvVoucherNo: [{validator: checkNull, trigger: 'blur'}],
                    warehouseId: [{validator: checkNull, trigger: 'blur'}]
                },
                selectItems: [],
                invoiceStateList: getEnumList("invoiceState"),
                invoiceStateMap: getEnumMap("invoiceState", "value2text"),
                invoiceTypeList: [],
                invoiceTypeMap: getEnumMap("invoiceType", "value2text"),
                assetTypeMap: getEnumMap("assetType", "value2text"),
                warehouseId: null,
                warehouseList: [],
                showBizUnitWarehouse: false,
            }
        },
        created: function () {
            let self = this;
            let invoiceTypeList = getEnumList("invoiceType");
            let dataList = [];
            for (let i = 0; i < invoiceTypeList.length; i++) {
                let invoiceType = invoiceTypeList[i];
                if (invoiceType.name == 'Plain' || invoiceType.name == 'Special') {
                    dataList.push(invoiceType);
                }
            }
            this.invoiceTypeList = Utils.merge([], dataList);
            getMerchantBizParam("show.biz.unit.warehouse", function (result) { // 显示门店/机构的仓库： {}
                self.showBizUnitWarehouse = Utils.isTrue(result);
            });
            //
            this.getWarehouseList(this.recvBizUnitId);
            this.getRetailerCom(this.recvShopId);
            //
            if (!Utils.isNoB(this.id)) {
                this.getpurchReceiptDetail();
            } else {
                if (!Utils.isNoB(this.purchReceiptParam) && !Utils.isNoB(this.purchReceiptParam.recvVoucherId)) {
                    let purchReceipt = this.purchReceiptParam || {};
                    purchReceipt.itemList = [];
                    this.purchReceipt = Utils.merge({}, purchReceipt);
                    self.getGoodsRecvVoucherItemRelAssets(purchReceipt.recvVoucherId, function (goodsRecvVoucherItemList) {
                        let resultList = [];
                        goodsRecvVoucherItemList.forEach(function (row) {
                            let theBool = ((row.quantity || 0) - (row.returnSumQuantity || 0) - (row.exchgSumQuantity || 0) > (row.assetCheckedQuantity || 0)) && ((!row.setupFlag || row.setupDone) && (!row.asmblFlag || row.asmblDone) || row.assetType != 0);
                            if (theBool) {
                                resultList.push(row);
                            }
                        });
                        self.handleItemList(resultList);
                    });
                }
            }
        },
        methods: {
            checkModel: function (rule, value, callback) {
                if (Utils.isNoB(value) && Utils.isFalse(this.buildFlag)) {
                    callback(new Error('不能为空!'));
                } else {
                    callback();
                }
            },
            getRetailerCom(comId){
                let self = this;
                retailerApi.getRetailerCom({
                    comId: comId
                }, function (result) {
                    if (result.type == 'info') {
                        self.principalId = result.data.principalId;
                    }
                });
            },
            changeAutoReceive: function () {
                if (Utils.isNoB(this.principalId)) {
                    let purchReceipt = this.purchReceipt || {};
                    purchReceipt.autoReceive = false;
                    this.purchReceipt = Utils.merge({}, purchReceipt);
                    //
                    MsgBox.warning("请先设置机构责任人");
                }
            },
            getWarehouseList(recvBizUnitId){
                let self = this;
                let postData = {};
                if (!Utils.isNoB(recvBizUnitId)) {
                    postData.filterItems = {
                        retailerShopId: recvBizUnitId
                    };
                }
                let msgBoxDlg = MsgBox.loading();
                shopStockApi.getShopWarehouseNotPageList(postData, function (result) {
                    msgBoxDlg.close();
                    if (result.type == 'info') {
                        let warehouseList = result.data;
                        if (warehouseList.length > 0) {
                            warehouseList.forEach(function (row) {
                                if (row.defaulted == true) {
                                    self.warehouseId = row.id;
                                }
                            })
                        }
                        self.warehouseList = Utils.merge([], warehouseList);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            taxRateChange: function (row) {
                let taxRate = row.taxRate;
                if (!Utils.isNoB(taxRate)) {
                    if (!Utils.isMoneyStr(taxRate)) {
                        taxRate = null;
                        MsgBox.warning("请输入有效的税率！");
                    } else {
                        let taxRateF = parseFloat(taxRate);
                        if (taxRateF > 100) {
                            taxRate = null;
                            MsgBox.warning("税率不能超过100！");
                        } else {
                            taxRate = taxRateF.toFixed(2);
                        }
                    }
                } else {
                    taxRate = null;
                }
                //
                let wtxPrice = row.wtxPrice || 0;
                let ntxPrice = row.ntxPrice || 0;
                if (Utils.isNoB(taxRate)) {
                    wtxPrice = ntxPrice;
                } else {
                    wtxPrice = ntxPrice * (1 + taxRate * 0.01);
                }
                row.wtxPrice = (parseFloat(wtxPrice) || 0).toFixed(2);
                //
                if (Utils.isNoB(taxRate)) {
                    MsgBox.warning("请输入税率！");
                    return;
                }
                row.taxRate = taxRate;
            },
            quantityChange: function (row) {
                let quantity = row.quantity;
                if (!Utils.isNoB(quantity)) {
                    if (!Utils.isNaturalStr(quantity) || quantity <= 0) {
                        row.quantity = null;
                        MsgBox.warning("只能输入大于0的整数！");
                    } else {
                        let recvQuantity = row.recvQuantity || 0;
                        let assetCheckedQuantity = row.assetCheckedQuantity || 0;
                        let returnSumQuantity = row.returnSumQuantity || 0;
                        let exchgSumQuantity = row.exchgSumQuantity || 0;
                        if (parseInt(quantity) > (parseInt(recvQuantity) - parseInt(returnSumQuantity) - parseInt(exchgSumQuantity) - parseInt(assetCheckedQuantity))) {
                            row.quantity = null;
                            MsgBox.warning("验收数量超过了可验收数量【" + (parseInt(recvQuantity) - parseInt(returnSumQuantity) - parseInt(exchgSumQuantity) - parseInt(assetCheckedQuantity)) + "】！");
                        }
                    }
                }
            },
            // 选择未验收完的发货单
            selectRecvVoucher: function () {
                let self = this;
                let purchReceipt = self.purchReceipt || {};
                let selectIds = [];
                if (!Utils.isNoB(purchReceipt.recvVoucherId) && purchReceipt.recvVoucherId > 0) {
                    selectIds.push(purchReceipt.recvVoucherId);
                }
                let params = {
                    selectIds: selectIds,
                    filter: {
                        devcCheckDone: false,
                        ioFlag: 1,
                        ukUnIoDoneQuantity: 0
                    }
                };
                showGoodsRecvVoucherListForSelectDialog(params, function (recvVoucher) {
                    recvVoucher = recvVoucher || {};
                    if(recvVoucher.buyerComId != null) {
                        let comInfo = {};
                        comInfo.id = recvVoucher.buyerComId;
                        let isAllowed = isSysRescFrozenIsAllowed(self, comInfo);
                        if(!isAllowed) {
                            this.$message({
                                message: '当前选择的机构【' + recvVoucher.buyerComName + '】该业务已冻结，请重新选择！',
                                type: 'warning',
                                offset: '200'
                            });
                            return false;
                        }
                    }
                    if (recvVoucher.ukUnIoDoneQuantity == 0) {
                        purchReceipt.title = recvVoucher.title;
                        purchReceipt.buyerId = recvVoucher.buyerId;
                        purchReceipt.recvVoucherId = recvVoucher.id;
                        purchReceipt.recvVoucherNo = recvVoucher.no;
                        purchReceipt.recvDate = recvVoucher.receiveDate;
                        purchReceipt.tradeNo = recvVoucher.tradeNo;
                        purchReceipt.orderNo = recvVoucher.orderNo;
                        purchReceipt.sellerName = recvVoucher.sellerName;
                        purchReceipt.invoiceType = recvVoucher.invoiceType;
                        self.purchReceipt = Utils.merge({}, purchReceipt);
                        //
                        self.getGoodsRecvVoucherItemRelAssets(recvVoucher.id, function (goodsRecvVoucherItemList) {
                            let resultList = [];
                            goodsRecvVoucherItemList.forEach(function (row) {
                                let theBool = ((row.quantity || 0) - (row.returnSumQuantity || 0) - (row.exchgSumQuantity || 0) > (row.assetCheckedQuantity || 0)) && ((!row.setupFlag || row.setupDone) && (!row.asmblFlag || row.asmblDone) || row.assetType != 0);
                                if (theBool) {
                                    resultList.push(row);
                                }
                            });
                            self.handleItemList(resultList);
                        });
                    } else {
                        self.$confirm('当前收货单还有未扫码确认的商品，继续验收可能出现二维码信息与设备信息不一致的情况，是否确定验收。', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(function () {
                            purchReceipt.title = recvVoucher.title;
                            purchReceipt.buyerId = recvVoucher.buyerId;
                            purchReceipt.recvVoucherId = recvVoucher.id;
                            purchReceipt.recvVoucherNo = recvVoucher.no;
                            purchReceipt.recvDate = recvVoucher.receiveDate;
                            purchReceipt.tradeNo = recvVoucher.tradeNo;
                            purchReceipt.orderNo = recvVoucher.orderNo;
                            purchReceipt.sellerName = recvVoucher.sellerName;
                            purchReceipt.invoiceType = recvVoucher.invoiceType;
                            self.purchReceipt = Utils.merge({}, purchReceipt);
                            //
                            self.getGoodsRecvVoucherItemRelAssets(recvVoucher.id, function (goodsRecvVoucherItemList) {
                                let resultList = [];
                                goodsRecvVoucherItemList.forEach(function (row) {
                                    let theBool = ((row.quantity || 0) - (row.returnSumQuantity || 0) - (row.exchgSumQuantity || 0) > (row.assetCheckedQuantity || 0)) && ((!row.setupFlag || row.setupDone) && (!row.asmblFlag || row.asmblDone) || row.assetType != 0);
                                    if (theBool) {
                                        resultList.push(row);
                                    }
                                });
                                self.handleItemList(resultList);
                            });
                        }).catch(function () {

                        })
                    }
                    self.getWarehouseList(recvVoucher.buyerBizUnitId);
                    self.getRetailerCom(recvVoucher.buyerShopId);
                });
            },
            // 选择发货条目
            selectRecvItems: function () {
                let self = this;
                let purchReceipt = self.purchReceipt || {};
                let recvVoucherId = purchReceipt.recvVoucherId;
                if (Utils.isNoB(recvVoucherId)) {
                    MsgBox.warning("请选择收货单！");
                    return;
                }
                let ioFlag = 1;
                let assetTypes = [0, 1];
                let selectItems = this.selectItems;
                showGoodsRecvVoucherItemListForSelectDialog(recvVoucherId, null, ioFlag, null, selectItems, "check", assetTypes, function (recvItems) {
                    self.handleItemList(recvItems);
                });
            },
            handleItemList(recvItems){
                let self = this;
                let purchReceipt = this.purchReceipt || {};
                recvItems = recvItems || [];
                //
                let itemList = [];
                for (let i = 0; i < recvItems.length; i++) {
                    let recvItem = recvItems[i];
                    let item = {
                        orderId: recvItem.orderId,
                        orderItemId: recvItem.orderItemId,
                        recvVoucherItemId: recvItem.id,
                        recvVoucherId: recvItem.voucherId,
                        shipVoucherItemId: recvItem.shipVoucherItemId,
                        recvDevcItemId: recvItem.devcItemId,
                        assetType: recvItem.assetType,
                        assetDefId: recvItem.assetDefId,
                        tmpNo: recvItem.tmpNo,
                        model: recvItem.model,
                        fixedSpec: recvItem.fixedSpec,
                        skuId: recvItem.skuId,
                        goodsId: recvItem.goodsId,
                        goodsTitle: recvItem.title,
                        catName: recvItem.catName,
                        brandName: recvItem.brandName,
                        recvQuantity: recvItem.quantity,
                        exchgSumQuantity: recvItem.exchgSumQuantity,
                        returnSumQuantity: recvItem.returnSumQuantity,
                        assetCheckedQuantity: recvItem.assetCheckedQuantity,
                        quantity: recvItem.checkedQuantity,
                        unit: recvItem.unit,
                        ntxPrice: recvItem.ntxPrice,
                        taxRate: recvItem.taxRate,
                        taxRateDisabled: !Utils.isTrue(recvItem.taxOffset),
                        wtxPrice: recvItem.price,
                        taxOffset: recvItem.taxOffset,
                        invoiceState: getEnumInfoWith('invoiceState', 'name', 'NotYet').value,
                        invoiceType: purchReceipt.invoiceType,
                        theUnit: recvItem.theUnit,
                        customized: recvItem.customized
                    };
                    itemList.push(item);
                    purchReceipt.taxOffset = recvItem.taxOffset;
                }
                //
                purchReceipt.itemList = Utils.merge([], itemList);
                self.selectItems = Utils.merge([], recvItems);
                self.purchReceipt = Utils.merge({}, purchReceipt);
            },
            // 移除商品
            removeGoods: function (index) {
                let purchReceipt = this.purchReceipt || {};
                let itemList = purchReceipt.itemList || [];
                let deleteTmpNo = itemList[index].tmpNo;
                let deleteRecvVoucherItemId = itemList[index].recvVoucherItemId;
                itemList.splice(index, 1);
                purchReceipt.itemList = Utils.merge([], itemList);
                //
                let selectItems = this.selectItems || [];
                for (let i = 0; i < selectItems.length; i++) {
                    let selectItem = selectItems[i];
                    if (selectItem.assetType == 0) {
                        if (deleteTmpNo == selectItem.tmpNo) {
                            selectItems.splice(i, 1);
                            break;
                        }
                    } else {
                        if (deleteRecvVoucherItemId == selectItem.id) {
                            selectItems.splice(i, 1);
                            break;
                        }
                    }
                }
                this.selectItems = Utils.merge([], selectItems);
                this.purchReceipt = Utils.merge({}, purchReceipt);
            },
            // 查看资产定义详情
            getpurchReceiptDetail: function () {
                let self = this;
                let postData = {};
                postData.id = self.id;
                //
                let msgBoxDlg = MsgBox.loading();
                receiptApi.getPurchReceiptInfo(postData, function (result) {
                    msgBoxDlg.close();
                    if (result.type == 'info') {
                        let purchReceipt = result.data;
                        self.purchReceipt = Utils.merge({}, purchReceipt);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 刷新数量
            refreshQuantity: function () {
                let self = this;
                let purchReceipt = self.purchReceipt || {};
                let keys = [];
                let itemList = purchReceipt.itemList || [];
                for (let i = 0; i < itemList.length; i++) {
                    let item = itemList[i];
                    let key = item.recvVoucherItemId + '_' + item.shipVoucherItemId + '_' + item.skuId;
                    if (item.assetType == 0 && !Utils.isNoB(item.tmpNo)) {
                        key = key + '_' + item.tmpNo;
                    }
                    keys.push(key);
                }
                if (keys.length > 0) {
                    let postData = {
                        keys: keys
                    };
                    goodsDelivApi.getGoodsRecvVoucherItemQuantityList(postData, function (result) {
                        if (result.type == "info") {
                            let quantityMap = result.data;
                            let returnMap = quantityMap['return'] || {};
                            let checkedMap = quantityMap['checked'] || {};
                            for (let i = 0; i < itemList.length; i++) {
                                let item = itemList[i];
                                let key = item.recvVoucherItemId + '_' + item.shipVoucherItemId + '_' + item.skuId;
                                if (item.assetType == 0 && !Utils.isNoB(item.tmpNo)) {
                                    key = key + '_' + item.tmpNo;
                                }
                                item.returnSumQuantity = returnMap[key] || 0;
                                item.assetCheckedQuantity = checkedMap[key] || 0;
                            }
                            purchReceipt.itemList = Utils.merge([], itemList);
                            //
                            self.purchReceipt = Utils.merge({}, purchReceipt);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }
            },
            getGoodsRecvVoucherItemRelAssets: function (voucherId, callback) {
                let self = this;
                let postData = {};
                postData.voucherId = voucherId;
                postData.useFor = 'check';
                postData.ioFlag = 1;
                postData.invalid = false;
                postData.assetTypes = [0, 1];
                postData.receiptStates = [0, -1];   // 未验收 or 已作废（购置验收的作废的）可以重新验收
                //
                let msgBoxDlg = MsgBox.loading();
                goodsDelivApi.getGoodsRecvVoucherItemRelAssetList(postData, function (result) {
                    msgBoxDlg.close();
                    if (result.type == "info") {
                        self.getItemQuantityMap(result.data, function (goodsRecvVoucherItemList) {
                            callback(goodsRecvVoucherItemList);
                        });
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            getItemQuantityMap: function (goodsRecvVoucherItemList, callback) {
                let keys = [];
                for (let i = 0; i < goodsRecvVoucherItemList.length; i++) {
                    let item = goodsRecvVoucherItemList[i];
                    let key = item.id + '_' + item.shipVoucherItemId + '_' + item.skuId;
                    if (item.assetType == 0 && !Utils.isNoB(item.tmpNo)) {
                        key += ('_' + item.tmpNo);
                    }
                    keys.push(key);
                }
                if (keys.length <= 0) {
                    return;
                }
                let postData = {
                    keys: keys
                };
                let msgBoxDlg = MsgBox.loading();
                goodsDelivApi.getGoodsRecvVoucherItemQuantityList(postData, function (result) {
                    msgBoxDlg.close();
                    if (result.type == "info") {
                        let quantityMap = result.data;
                        let exchgMap = quantityMap['exchg'] || {};
                        let returnMap = quantityMap['return'] || {};
                        let checkedMap = quantityMap['checked'] || {};
                        let assetInMap = quantityMap['assetIn'] || {};
                        for (let i = 0; i < goodsRecvVoucherItemList.length; i++) {
                            let item = goodsRecvVoucherItemList[i];
                            let key = item.id + '_' + item.shipVoucherItemId + '_' + item.skuId;
                            if (item.assetType == 0 && !Utils.isNoB(item.tmpNo)) {
                                key += ('_' + item.tmpNo);
                            }
                            item.exchgSumQuantity = exchgMap[key] || 0;
                            item.returnSumQuantity = returnMap[key] || 0;
                            item.assetCheckedQuantity = checkedMap[key] || 0;
                            if (item.assetType == 0) {
                                if (!Utils.isNoB(item.tmpNo)) {
                                    item.quantity = 1;
                                }
                                item.assetInQuantity = assetInMap[key] || 0;
                                item.checkedQuantity = item.quantity - item.returnSumQuantity - item.exchgSumQuantity - item.assetCheckedQuantity;
                            } else if (item.assetType == 1) {
                                item.checkedQuantity = item.quantity - item.returnSumQuantity - item.exchgSumQuantity - item.assetCheckedQuantity;
                            } else if (item.assetType == 3) {
                                item.checkedQuantity = item.quantity - item.returnSumQuantity - item.exchgSumQuantity - item.assetCheckedQuantity;
                            }
                        }
                        callback(goodsRecvVoucherItemList);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 返回数据
            getDlgResult: function () {
                let self = this;
                let result = {};
                this.$refs['ruleForm'].validate(function (valid) {
                    if (valid) {
                        //
                        self.refreshQuantity();
                        //
                        let purchReceipt = self.purchReceipt;
                        let itemList = purchReceipt.itemList || [];
                        if (Utils.isNoB(purchReceipt.recvVoucherId)) {
                            result.type = 'warn';
                            result.message = '请选择收货单!';
                        } else if (itemList.length <= 0) {
                            result.type = 'warn';
                            result.message = '请选择要验收的商品!';
                        } else if (Utils.isNoB(self.warehouseId)) {
                            result.type = 'warn';
                            result.message = '请选择入库仓库!';
                        } else {
                            if (!Utils.isNoB(self.id)) {
                                purchReceipt.id = self.id;
                            }
                            //
                            let quantityNullMsg = '';
                            let quantityMsg = '';
                            for (let i = 0; i < itemList.length; i++) {
                                let devcItem = itemList[i];
                                let quantity = devcItem.quantity || 0;
                                let recvQuantity = devcItem.recvQuantity || 0;
                                let assetCheckedQuantity = devcItem.assetCheckedQuantity || 0;
                                let returnSumQuantity = devcItem.returnSumQuantity || 0;
                                if (parseInt(quantity) <= 0) {
                                    if (Utils.isNoB(quantityNullMsg)) {
                                        quantityNullMsg = '请输入商品【' + devcItem.goodsTitle + '】';
                                    } else {
                                        quantityNullMsg += '、【' + devcItem.goodsTitle + '】';
                                    }
                                } else {
                                    if (parseInt(quantity) > (recvQuantity - returnSumQuantity - assetCheckedQuantity)) {
                                        MsgBox.warning("验收数量超过了可验收数量【" + (recvQuantity - returnSumQuantity - assetCheckedQuantity) + "】！");
                                        if (Utils.isNoB(quantityMsg)) {
                                            quantityMsg = '商品【' + devcItem.goodsTitle + '】验收数量超过了可验收数量【' + (recvQuantity - returnSumQuantity - assetCheckedQuantity) + '】';
                                        } else {
                                            quantityMsg += '、【' + devcItem.goodsTitle + '】验收数量超过了可验收数量【' + (recvQuantity - returnSumQuantity - assetCheckedQuantity) + '】';
                                        }
                                    }
                                }
                            }
                            let errMsg = '';
                            if (!Utils.isNoB(quantityNullMsg)) {
                                errMsg = quantityNullMsg + '的验收数量！';
                            }
                            if (!Utils.isNoB(quantityMsg)) {
                                if (!Utils.isNoB(errMsg)) {
                                    errMsg += quantityMsg;
                                } else {
                                    errMsg = quantityMsg;
                                }
                            }
                            if (!Utils.isNoB(errMsg)) {
                                result.type = 'warn';
                                result.message = errMsg;
                            } else {
                                //
                                purchReceipt.warehouseId = self.warehouseId;
                                let warehouseList = self.warehouseList || [];
                                for (let i = 0; i < warehouseList.length; i++) {
                                    let warehouse = warehouseList[i];
                                    if (self.warehouseId == warehouse.id) {
                                        purchReceipt.warehouseName = warehouse.name;
                                        break;
                                    }
                                }
                                //
                                result.type = 'info';
                                result.data = purchReceipt;
                            }
                        }
                    } else {
                        result.type = 'warn';
                        result.message = '校验失败';
                    }
                });
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/receipt/PurchReceiptSave.vue